export function toMultiplyItemsOfTwoArrays(weight, accountFormated) {
  const multiplicateNumbers = weight.map((item, index) => {
    return item * accountFormated[index]
  })
  return multiplicateNumbers
}

export default toMultiplyItemsOfTwoArrays
